import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import { computed, ref } from 'vue';
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { BcxFormField } from '@/models/BcxForm';
import useI18n from '@/mixins/useI18n';
import { watchDebounced } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceTexts',
  setup(__props) {

const { t } = useI18n();

const autoSaveTrigger = ref(0);

const data = ref({
  title: 'Rechnung',
  introductionText: 'Hiermit stelle ich Ihnen folgende Dienstleistungen in Rechnung: ',
  endingText: `Bitte überweisen Sie den Betrag bis zum {paymentDeadline}

mit freundlichen Grüßen,
Robert Hansen`,
});

const fields = computed(() => {
  const fields:BcxFormField[] = [
    {
      name: 'title',
      width: '100%',
      label: `${t('invoice.texts.form.title')}`,
      type: 'text',
      textOptions: { maxLength: 60 }
    },
    {
      name: 'introductionText',
      width: '100%',
      label: `${t('invoice.texts.form.introductionText')}`,
      type: 'textarea',
      textareaOptions: {
        maxLength: 500,
        height: 100
      }
    },
    {
      name: 'endingText',
      width: '100%',
      label: `${t('invoice.texts.form.endingText')}`,
      type: 'textarea',
      textareaOptions: {
        maxLength: 500,
        height: 100
      }
    },
  ];
  return fields;
});

watchDebounced(data, () => {
  autoSaveTrigger.value++;
}, { debounce: 500 });


return { __sfc: true,t, autoSaveTrigger, data, fields, InvoiceSection, BCXForm }
}

})